import { useEffect, useState } from "react";
import { database } from "../firebase/FirebaseConfig";
import { ref, push, serverTimestamp } from "firebase/database";
import { getUserData } from "../Hooks/getUserData";

// Cookies get Functions
const getCookie = (name) => {
  const nameEQ = name + "=";
  const cookies = document.cookie.split(";");
  for (let i = 0; i < cookies.length; i++) {
    let cookie = cookies[i].trim();
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length);
    }
  }
  return null;
};

// Function to set cookies
const setCookie = (clickID, days) => {
  let expires = "";
  if (days) {
    const date = new Date();
    date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
    expires = "; expires=" + date.toUTCString();
  }
  document.cookie = `MB=${clickID}${expires}; path=/; domain=.markenbreit.com; Secure; SameSite=None`;
};

// Save to firebase success (ASYNC)
const saveToDatabase = async (userData, clickID = null) => {
  try {
    const dataRef = ref(database, `clicks`);
    const newEntry = await push(dataRef, {
      ...userData,
      clickID: clickID,
      timestamp: serverTimestamp(),
    });
    return newEntry.key; 
  } catch (error) {
    console.error("❌ Error to save in Firebase:", error);
    throw error;
  }
};

// SaveData Component
const SaveData = () => {
  const [userData, setUserData] = useState(null);

  useEffect(() => {
    const fetchUserData = async () => {
      const data = await getUserData();
      setUserData(data);
    };
    fetchUserData();
  }, []);

  useEffect(() => {
    if (!userData) return;

    /*
    const getLastUrlParameter = () => {
      const url = window.location.href;
      const parts = url.split("/");
      return parts[parts.length - 1];
    };*/

    const getLastUrlParameter = () => {
      const url = window.location.href;
    
      // Split the URL into parts using "/" and take the last segment without query parameters
      const parts = url.split("/");
      const lastPath = parts[parts.length - 1].split("?")[0]; // Last path without query parameters
    
      // Extract query parameters using URLSearchParams
      const searchParams = new URLSearchParams(window.location.search);
    
      // Convert query parameters into an object
      const paramsObject = {};
      searchParams.forEach((value, key) => {
        paramsObject[key] = value;
      });
    
      return {
        campaignID: lastPath || "", // The last part of the URL path
        queryParamsObject: paramsObject || {}, // Query parameters as a JavaScript object
        queryParamsString: window.location.search.substring(1) || "", // Query parameters as a string (including "?")
      };
    };
    
    const campaign = getLastUrlParameter();
    const campaignID = campaign.campaignID;

    const source = {
      f: "Facebook",
      r: "Rumble",
      i: "Instagram",
      y: "YouTube",
      t: "TikTok",
      d: "Direct",
      g: "Google Ads",
      n: "Newsletter",
      x: "X (Twitter)",
      o: "Other",
      a: "App Store",
      p: "Playstore",
      s: "Snapchat",
      w: "Whatsapp",
      e: "Email",
      l: "LinkedIn",
      h: "Github",
    }

    const sourceType = {
      v: "Paid",
      l: "Organic"
    };

    const targets = {
      h: "https://markenbreit.com/",
      w: "https://markenbreit.com/website",
      l: "https://markenbreit.com/landingpage",
      s: "https://markenbreit.com/online-shop",
      d: "https://markenbreit.com/logo-design",
      j: "https://jobs.markenbreit.com/",
      y: "https://youtu.be/bWao1a27bSQ",
    };

    const targetKey = campaignID[0]?.toLowerCase() || "";
    const target = targets[targetKey] || "https://markenbreit.com/";
    const sourceKey = campaignID[1]?.toLowerCase() || "";
    const sourceValue = source[sourceKey] || "Unknown";
    const sourceTypeKey = campaignID[2]?.toLowerCase() || "";
    const sourceTypeValue = sourceType[sourceTypeKey] || "Unknown";
    

    const clickID = getCookie("MB");

    const saveAndRedirect = async () => {
      try {
        const key = await saveToDatabase({ 
          ...userData, 
          campaign: campaignID.substring(2), 
          campaignFull: campaignID, 
          params: { ...campaign.queryParamsObject }, 
          source: sourceValue, 
          target: target, 
          type: sourceTypeValue
        }, clickID);
        setCookie(key, 30);
    
        const separator = target.includes("?") ? "&" : "?";
        const extraParams = campaign.queryParamsString ? `&${campaign.queryParamsString}` : "";
        window.location.href = `${target}${separator}id=${key}${extraParams}`;
      } catch (error) {
        console.error("❌ Error save data:", error);
        window.location.href = target;
      }
    };

    saveAndRedirect();
  }, [userData]);

  return (<div className="a">
    <div className="b" />
    <p className="c">Cargando</p>
  </div>);
};

export default SaveData;
